import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiShield, FiZap } = FiIcons;

const UrgencyRisk = () => {
  return (
    <section className="py-16 relative">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass-card rounded-3xl p-8 md:p-12 border-teal/20 bg-teal/5 text-center relative overflow-hidden"
        >
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-teal-600 via-teal to-teal-600"></div>
          
          <div className="grid md:grid-cols-3 gap-8 items-center divide-y md:divide-y-0 md:divide-x divide-white/10">
            <div className="flex flex-col items-center p-4">
              <SafeIcon icon={FiShield} className="text-teal text-4xl mb-4" />
              <h4 className="text-white font-bold text-xl mb-2">Deep Analysis</h4>
              <p className="text-slate-400 text-sm">Comprehensive review of your online trust architecture.</p>
            </div>
            
            <div className="flex flex-col items-center p-4">
              <SafeIcon icon={FiZap} className="text-teal text-4xl mb-4" />
              <h4 className="text-white font-bold text-xl mb-2">Fast Request</h4>
              <p className="text-slate-400 text-sm">Takes less than 2 minutes to fill out the form below.</p>
            </div>
            
            <div className="flex flex-col items-center p-4">
              <SafeIcon icon={FiClock} className="text-teal text-4xl mb-4" />
              <h4 className="text-white font-bold text-xl mb-2">Clear Roadmap</h4>
              <p className="text-slate-400 text-sm">You receive your personalized action plan quickly.</p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10">
            <p className="inline-block bg-rose-500/20 text-rose-300 border border-rose-500/30 px-6 py-2 rounded-full font-bold text-sm tracking-wide uppercase shadow-[0_0_15px_rgba(244,63,94,0.2)] animate-pulse">
              Only a Limited Number of Audits Taken Per Week
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UrgencyRisk;